import {useContext} from "react";

import {
    TextToSpeechOnboardingContext,
    type TextToSpeechOnboardingState,
} from "./text-to-speech-onboarding-context.ts";

/**
 * Provide access to the text-to-speech onboarding state/controls.
 */
export const useTextToSpeechOnboarding = (): TextToSpeechOnboardingState =>
    useContext(TextToSpeechOnboardingContext);
